// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import PrivateProfile from '../_raw/ui/icon_private_profile.svg';
import withIconProps from '../withIconProps';

export default withIconProps(PrivateProfile);
